module.exports = __webpack_public_path__ + "static/media/orange-checkmark.7b48e36a.svg";